// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1Sdwv","rootSuccess":"CompleteLink_rootSuccess__1QqeN","rootFailure":"CompleteLink_rootFailure__3Y-mR","isDisabled":"CompleteLink_isDisabled__3yq7m"};